import { inject, injectable } from 'inversify';
import ProductsService from 'src/features/products/data/service/ProductsService';
import { StoreStockResponse } from 'src/features/products/data/service/ProductsService.types';
import {
  GetAllProductsOnPromotionUseCaseInterface,
  ProductsOnPromotionListParams,
} from 'src/features/products/domain/useCases/types';

@injectable()
class ProductsOnPromotionListUseCase
  implements GetAllProductsOnPromotionUseCaseInterface
{
  @inject(ProductsService) private productsService!: ProductsService;

  async execute(
    params: ProductsOnPromotionListParams
  ): Promise<StoreStockResponse> {
    const response = await this.productsService.getProductsOnPromotion(params);

    return response.data as StoreStockResponse;
  }
}

export default ProductsOnPromotionListUseCase;
